import { useNavigate } from 'react-router';
import Icon from '../components/Icon';
import SignInSettings from '../components/SignInSettings';
import { useAppPath } from '../lib/AppContext';

// Settings › Đăng nhập và bảo mật: the ways to sign in (Zalo, Google, Apple) and the optional password.
export default function SecurityPage() {
  const path = useAppPath();
  const navigate = useNavigate();
  return (
    <div className="flex flex-col gap-1">
      <div className="pt-safe flex items-center gap-1 pt-4">
        <button type="button" className="btn btn-circle btn-ghost -ml-2 size-11" aria-label="Quay lại" onClick={() => navigate(path('/settings'))}>
          <Icon name="chevronLeft" className="size-6" />
        </button>
        <h1 className="text-[22px] font-bold">Đăng nhập và bảo mật</h1>
      </div>
      <SignInSettings />
    </div>
  );
}
